import React from "react";
import { useParams } from "react-router-dom";
import useFileDocuments from "../actions/useFileDocuments";
import Folders from "./Folders";
import FolderSkeleton from "./FolderSkeleton";
import SearchFIles from "./SearchFIles";

const TypeFileDocuments = () => {
  const { id, service_id, type } = useParams();
  const {
    states,
    handleClickType,
    fileName,
    setFileName,
    rows,
    first,
    onPageChange,
  } = useFileDocuments({
    id,
    service_id,
    type,
  });
  return (
    <>
      {states.loading ? (
        <FolderSkeleton />
      ) : (
        <>
          {!states.folders ? (
            <SearchFIles
              fileName={fileName}
              setFileName={setFileName}
              additionaltag={{ entity: [states?.entity_detail?.name] }}
              states={states}
              first={first}
              rows={rows}
              onPageChange={onPageChange}
            />
          ) : (
            <div className="service-folder-container">
              {states?.folders?.length > 0 && (
                <p className="document-sub-heading"> Folders</p>
              )}
              {states.loading ? (
                <FolderSkeleton />
              ) : (
                <Folders
                  folders={states?.folders}
                  onFolderClick={handleClickType}
                />
              )}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default TypeFileDocuments;
